import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
// import reportWebVitals from './reportWebVitals';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from "@mui/material/styles";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';

import App from 'App';
import theme from 'Styles/theme';
import GlobalStateProvider from 'Providers/GlobalStateProvider';
import CircularLoader from 'Components/Loaders/CircularLoader';

import './i18n';

ReactDOM.render(
	<React.StrictMode>
		<Suspense fallback={<CircularLoader />}>
			<GlobalStateProvider>
				<ThemeProvider theme={theme}>
					<CssBaseline>
						<LocalizationProvider dateAdapter={AdapterDateFns}>
							<App />
						</LocalizationProvider>
					</CssBaseline>
				</ThemeProvider>
			</GlobalStateProvider>
		</Suspense>
	</React.StrictMode>,
	document.getElementById('root')
);